/**
 * Document Type Enum
 *
 * Represents the type of document content detected through classification.
 * Used across workflow steps to determine processing logic.
 */
export enum DocumentType {
  PURCHASE_ORDER = "purchase_order",
  AP_INVOICE = "ap_invoice",
  AP_INVOICE_UPDATE = "ap_invoice_update",
  SPECIAL_PRICE_REQUEST = "special_price_request",
  OTHER = "other",
}
